<nz-layout class="auth auth--reset-password">
  <div nz-row class="auth__container">
    <div nz-col nzSpan="24" class="auth__content">
      <div nz-row nzJustify="center">
        <div nz-col nzSpan="24" class="auth__logo">
          <div class="auth__logo-wrap">
            <img class="logo-img" src="/assets/images/logo.svg" alt="Momhunting logo" />
          </div>
        </div>
        <ng-container *ngIf="!referenceComplete && !referenceRejected">
          <div nz-col nzSpan="24">
            <h1 class="auth__title" [innerHtml]="'make-reference.title' | translate : { authorName: authorName, targetName: targetName }"></h1>
          </div>
          <div nz-col nzSpan="24">
            <p class="auth__text" [innerHtml]="'make-reference.text' | translate : { authorName: authorName, targetName: targetName }"></p>
          </div>
          <div nz-col nzSpan="24">
            <form nz-form [formGroup]="formGroup" nzLayout="vertical">
              <nz-form-item>
                <nz-form-label>
                  <mh-explanation-label [labelKey]="'make-reference.reference.label'"></mh-explanation-label>
                </nz-form-label>
                <nz-form-control>
                  <textarea rows="4" formControlName="referenceText" nz-input></textarea>
                </nz-form-control>
              </nz-form-item>
            </form>
          </div>
          <div class="auth__form auth__form--space-between">
            <button nz-button nzType="default" nzSize="large" [disabled]="referenceComplete" (click)="onReject()">
              {{ "reject.button" | translate }}
            </button>
            <button nz-button nzType="primary" nzSize="large" [disabled]="referenceComplete" (click)="onMake()">
              {{ "make-reference.button" | translate }}
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="referenceComplete">
          <div nz-col nzSpan="24">
            <p class="auth__text" [innerHtml]="'make-reference.complete.text' | translate : { authorName: authorName, targetName: targetName }"></p>
          </div>
          <nz-result nzStatus="success"></nz-result>
        </ng-container>
        <ng-container *ngIf="referenceRejected">
          <div nz-col nzSpan="24">
            <h1 class="auth__title" [innerHtml]="'make-reference.reject.title' | translate : { authorName: authorName, targetName: targetName }"></h1>
          </div>
          <div nz-col nzSpan="24">
            <p class="auth__text" [innerHtml]="'make-reference.reject.text' | translate : { authorName: authorName, targetName: targetName }"></p>
          </div>
          <nz-result nzStatus="error"></nz-result>
        </ng-container>
      </div>
    </div>
  </div>
</nz-layout>
